'use client';

import { sendGTMEvent } from '@next/third-parties/google';
import { useEffect } from 'react';

export const TagManagerSet = () => {
  useEffect(() => {
    const root = document;
    const nodes = Array.from(root.querySelectorAll<HTMLElement>('[data-category-link]'));
    const handlers: Array<() => void> = [];

    nodes.forEach((el) => {
      const category = el.getAttribute('data-category-link') || '';
      const handler = () => {
        sendGTMEvent({
          event: 'category_click',
          category: category,
        });
      };
      el.addEventListener('click', handler);
      handlers.push(() => el.removeEventListener('click', handler));
    });

    return () => handlers.forEach((off) => off());
  }, []);

  return null;
};
